import React from 'react';
import { useSelector } from 'react-redux';
import DashboardMetrics from '../../components/admin/dashboard/DashboardMetrics';
import PendingApprovalSection from '../../components/admin/pendingApprovals/PendingApprovalSection';
import FiltersFieldsSection from '../../components/admin/filtersFields/FiltersFieldsSection';
import ManualEditsSection from '../../components/admin/manualEdits/ManualEditsSection';
// import BulkUploads from '../../components/admin/bulkUploads/BulkUploads';
import VideoRequestsSection from '../../components/admin/videoRequests/VideoRequestsSection';
import ReactivationRequestsSection from '../../components/admin/reactivationRequests/ReactivationRequestsSection';
import CancellationRequestsSection from '../../components/admin/cancellationRequests/CancellationRequestsSection';
// import BulkUploadsSection from '../../components/admin/bulkUploads/BulkUploadsSection';

const AdminDashboard = () => {
  const { summary } = useSelector((state) => state.admin);

  return (
    <div className="text-jp-ink">
      <DashboardMetrics metrics={summary} />

      <div className="mt-8">
        <PendingApprovalSection />
      </div>

      {/* <div className="mt-8">
        <FiltersFieldsSection />
      </div> */}

      <div className="mt-8">
        <ManualEditsSection />
      </div>
      

      <div className="mt-8">
        <VideoRequestsSection />
      </div>

      <div className="mt-8">
        <ReactivationRequestsSection />
      </div>

      <div className="mt-8">
        <CancellationRequestsSection />
      </div>

      {/* <div className="mt-8 w-2/3">
        <BulkUploads />
      </div> */}
    </div>
  );
};

export default AdminDashboard;
